import { render } from "./Multicare.vue?vue&type=template&id=529ca5de&scoped=true"
import script from "./Multicare.vue?vue&type=script&lang=js"
export * from "./Multicare.vue?vue&type=script&lang=js"

import "./Multicare.vue?vue&type=style&index=0&id=529ca5de&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-529ca5de"

export default script